
import { Button, ButtonProps } from '@dansk-metal/ui';

import { EventDto } from '@web/services/crm-api/rest';

import styles from './event-cancellation-confirmation.module.scss';

export type EventCancellationConfirmationProps = {
	onClose: ButtonProps['onClick'];
	event: EventDto;
};

export function EventCancellationConfirmation({ onClose, event }: EventCancellationConfirmationProps) {
	return (
		<div className={styles.container}>
			<div className={styles.head}>
				<h2>Afmelding</h2>
			</div>

			<div className={styles.section}>
				<h3>Afmelding gennemført</h3>

				<p>
					Du er nu afmeldt arrangementet “{event.title}”.
					Du vil også modtage en bekræftigelse på din afmelding via mail.
				</p>
			</div>

			<div className={styles.section}>
				<div>
					<div className={styles.button}>
						<Button icon={{ icon: 'arrow-right', size: 24 }} onClick={onClose}>
							Luk
						</Button>
					</div>
				</div>
			</div>
		</div>
	);
}
